export default __webpack_public_path__ + "static/media/lock_alert.f3abad87.mp3";